/**
 * Print store — print area management, color extraction, confirmation.
 */
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePrintStore = defineStore('print', () => {
  const confirmColors = ref<string[]>([]);
  const printType = ref('');
  const showConfirmation = ref(false);

  /** Colors used in the current design (extracted from items) */
  const usedColors = ref<string[]>([]);

  function setConfirmColors(colors: string[]) {
    confirmColors.value = colors;
  }

  function setPrintType(type: string) {
    printType.value = type;
  }

  function addUsedColor(color: string) {
    if (!usedColors.value.includes(color)) {
      usedColors.value.push(color);
    }
  }

  function clearUsedColors() {
    usedColors.value = [];
  }

  function openConfirmation() {
    showConfirmation.value = true;
  }

  function closeConfirmation() {
    showConfirmation.value = false;
  }

  return {
    confirmColors,
    printType,
    showConfirmation,
    usedColors,
    setConfirmColors,
    setPrintType,
    addUsedColor,
    clearUsedColors,
    openConfirmation,
    closeConfirmation,
  };
});
